import React, { ReactNode } from "react";

interface Props {
    children: ReactNode;
}

const Message: React.FC<Props> = ({
    children
}) => {
    return (
        <p>
            {children}
        </p>
    )
}

export default Message;